import errIcon from './img/modal/modal_err_icon.png';
import infoIcon from './img/modal/modal_info_icon.png';
import questionIcon from './img/modal/modal_question_icon.png';
import successIcon from './img/modal/modal_success_icon.png';
import warningIcon from './img/modal/modal_warn_icon.png';
import promptIcon from './img/modal/modal_warn_icon.png';

export class DialogIcons {
	static get Success(): string {
		return successIcon;
	}

	static get Info(): string {
		return infoIcon;
	}

	static get Error(): string {
		return errIcon;
	}

	static get Warning(): string {
		return warningIcon;
	}

	static get Question(): string {
		return questionIcon;
	}

	static get Prompt(): string {
		return promptIcon;
	}
}
